import React, { useEffect, useState } from "react";
import { usePrefs } from "@/contexts/PrefsContext";
import { CHANGED_EVENT } from "@/lib/live";

export const LiveIndicator = () => {
  const { t } = usePrefs();
  const [flash, setFlash] = useState(false);
  useEffect(() => {
    const h = () => setFlash(true);
    window.addEventListener(CHANGED_EVENT, h);
    return () => window.removeEventListener(CHANGED_EVENT, h);
  }, []);
  useEffect(() => {
    if (!flash) return;
    const id = setTimeout(() => setFlash(false), 1800);
    return () => clearTimeout(id);
  }, [flash]);
  return (
    <span data-testid="live-indicator" title={t("live.hint")}
      className={`inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11px] font-bold transition-[background-color,color] duration-500 ${flash ? "bg-emerald-500/20 text-emerald-700 dark:text-emerald-300" : "bg-muted text-muted-foreground"}`}>
      <span className="relative flex h-2 w-2">
        <span className={`absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75 ${flash ? "animate-ping" : ""}`} />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
      </span>
      <span className="hidden sm:inline">{t(flash ? "live.updated" : "live.on")}</span>
    </span>
  );
};
